import CookieConsentRenderer from "../utils/CookieConsent/Renderer";
import CookieUtils from "../interfaces/CookieUtils";
import { COOKIE_CONSENT_REQUIRED_COUNTRIES, GOOGLE_ANALYTICS_BANNED_COUNTRIES } from "../components/specific/CookieConsent/constants";

const NO_CF_HEADER_RETURNED = "NO CF COUNTRY NAME HEADER";

function disableGoogleAnalytics(gaMeasurementId, cookieNames, countryName) {
  if (GOOGLE_ANALYTICS_BANNED_COUNTRIES.includes(countryName)) {
    CookieUtils.setCookie(cookieNames.disableGa, "true");
    CookieUtils.disableGATracking(gaMeasurementId);
  }
  else{
    CookieUtils.deleteCookie(cookieNames.disableGa);
  }
}
function processConsentLogic(countryName, consentCookie, gaMeasurementId, cookieNames) {
  if (!countryName || countryName === NO_CF_HEADER_RETURNED) {
    if (!consentCookie) CookieConsentRenderer.renderApp("cjs-cookie-consent-popup");
    CookieUtils.disableGATracking(gaMeasurementId);
    return;
  }

  disableGoogleAnalytics(gaMeasurementId, cookieNames, countryName);
  const shouldShowBanner = COOKIE_CONSENT_REQUIRED_COUNTRIES.includes(countryName);
  CookieUtils.setCookie(cookieNames.showOptInConsentBanner, String(shouldShowBanner));

  if (shouldRenderConsentBanner(shouldShowBanner, consentCookie)){
    CookieConsentRenderer.renderApp("cjs-cookie-consent-popup");
  }
}

function shouldRenderConsentBanner(shouldShowBanner, consentCookie) {
  return shouldShowBanner && !consentCookie;
}

async function fetchCountryName(fetcherUrl) {
  try {
    const response = await fetch(fetcherUrl, { method: "GET" });
    const data = await response.json();
    return data.countryName || null;
  } catch {
    return null;
  }
}

async function handleCookieConsent() {
  const consentPopupElement = document.getElementById("cjs-cookie-consent-popup");

  const consentConstantsData = consentPopupElement.dataset["consentconstants"]
  const gaMeasurementId = consentPopupElement.dataset["gameasurementid"]
  const assetS3Url = consentPopupElement.dataset["assets3url"]
  const customCookiePolicy = consentPopupElement.dataset["customcookiepolicy"]
  const isFedRampComplaint = consentPopupElement.dataset["isfedrampcomplaint"]

  if (customCookiePolicy === "true" || isFedRampComplaint === "true") return;

  const { cookieNames = {} } = consentConstantsData ? JSON.parse(consentConstantsData) : {};

  if (!assetS3Url) {
    console.log("Asset S3 URL is missing.");
    return;
  }

  const countryFetcherUrl = `https://${assetS3Url}/cookiebanner`;

  try {
    const countryName = await fetchCountryName(countryFetcherUrl);
    const consentCookie = CookieUtils.getSafelyParsedCookieValue(cookieNames.cookieConsent);

    processConsentLogic(countryName, consentCookie, gaMeasurementId, cookieNames);
  } catch (error) {
    console.log("Error handling cookie consent:", error);
  }
}

documentOnReady(handleCookieConsent);
